/* tslint:disable */
/* eslint-disable */
/**
 * Eatgrim Shipping API
 * Eatgrim Shipping API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@soundsgood.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CountryFromJSON, CountryToJSON, } from './';
export function TypePayloadFromJSON(json) {
    return TypePayloadFromJSONTyped(json, false);
}
export function TypePayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'country': CountryFromJSON(json['country']),
        'shopifyProductId': json['shopifyProductId'],
    };
}
export function TypePayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'country': CountryToJSON(value.country),
        'shopifyProductId': value.shopifyProductId,
    };
}
